<ng-container [formGroup]="percentTableForm">
  <table mat-table [dataSource]="addends" class="percentage-table">
    <caption class="visually-hidden">Percentage Table</caption>

    <ng-container matColumnDef="allocees">
      <label for="allocees-to" class="visually-hidden">To</label>
      <th id="allocees-to" mat-header-cell *matHeaderCellDef> To: </th>
      <td mat-cell *matCellDef="let addend"> {{ addend.QuestionText }} </td>
      <td mat-footer-cell *matFooterCellDef> Total&nbsp;<sup *ngIf="tableHeader === 'IULPremPaymentAllocation'" class="asterisk">*</sup> </td>
    </ng-container>

    <ng-container matColumnDef="percentages">
      <label for="allocees-percentages" class="visually-hidden">Percentages</label>
      <th id="allocees-percentages" mat-header-cell *matHeaderCellDef>
        <ng-container *ngIf="tableHeader === 'IULPremPaymentAllocation' || tableHeader === 'IULFixedAcctAlloc'">Percent:</ng-container>
        <ng-container *ngIf="tableHeader === 'IULProceedsAllocToCompound'">% From {{fromAccount}}:</ng-container>
      </th>
      <td mat-cell *matCellDef="let addend">
        <div class="input-group">
          <ng-container *ngIf="!isPercent">
            <div class="input-group-prepend">
              <span class="input-group-text">$</span>
            </div>
          </ng-container>
          <input (keyup)="getTotal($event)" [cleave]="mask" [maxlength]="maxLength" class="form-control" [formControlName]="addend.QuestionName" [id]="addend.QuestionName" [type]="addend.inputType" tabindex="0" [ngClass]="{'input-required': isRequired && isEditable, 'disabled': !isEditable}">
          <ng-container *ngIf="isPercent">
            <div class="input-group-append">
              <span class="input-group-text">%</span>
            </div>
          </ng-container>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <div class="input-cover"></div>
        <div class="input-group">
          <ng-container *ngIf="!isPercent">
            <div class="input-group-prepend">
              <span class="input-group-text">$</span>
            </div>
          </ng-container>
          <label for="percentTotal" class="visually-hidden">Percent Total</label>
          <input id="percentTotal" *ngIf="isPercent" [cleave]="mask" type="text" class="form-control" tabIndex="-1" formControlName="PercentTotal" class="form-control custom-validator">
          <label for="dollarTotal" class="visually-hidden">Dollar Total</label>
          <input id="dollarTotal" *ngIf="!isPercent" [cleave]="mask" type="text" class="form-control" tabIndex="-1" formControlName="DollarTotal" class="form-control custom-validator">
          <ng-container *ngIf="isPercent">
            <div class="input-group-append">
              <span class="input-group-text">%</span>
            </div>
          </ng-container>
          <ng-container *ngIf="!isPercent">
            <div class="input-group-append">
              <span class="input-group-text clear">
                <ng-container *ngIf="!IULvalid">&ne;</ng-container>
                <ng-container *ngIf="IULvalid">=</ng-container> {{dollarTotal | currency:'USD':'symbol':'1.0-0'}}</span>
            </div>
          </ng-container>
        </div>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns" [ngClass]="{'green': IULvalid, 'red': IULOverShot}"></tr>

  </table>
  <error-messages [form]="parent" [field]="tableHeader + '.PercentTotal'" skipFeedback="true"></error-messages>
  <error-messages [form]="parent" [field]="tableHeader + '.DollarTotal'" skipFeedback="true"></error-messages>
</ng-container>
<ng-container *ngIf="tableHeader === 'IULProceedsAllocToCompound'"><hr style="margin-top:50px;margin-bottom:-30px;" /></ng-container>